import {Injectable} from '@angular/core';
import {ActivatedRoute} from '@angular/router';

export interface DerivativeParent {
  id: string;
  name: string;
}

@Injectable({
  providedIn: 'root'
})
export class OrderUpsellService {

  constructor(private activatedRoute: ActivatedRoute) {
  }

  getProduct(): string {
    return this.activatedRoute.snapshot.queryParamMap.get('product');
  }

  getProductName(): string {
    return this.activatedRoute.snapshot.queryParamMap.get('productName')?.replace(/[”"]/g, '');
  }

  getContractId(): string {
    return new URL(this.getFollowActionUrl()).searchParams.get('contract');
  }

  getDerivativeParent(): DerivativeParent[] {
    const derivativeParent: string = this.activatedRoute.snapshot.queryParamMap.get('derivativeParent');
    if (derivativeParent) {
      try {
        return JSON.parse(atob(derivativeParent));
      } catch (e) {
        throw new Error(e.message);
      }
    } else {
      return null;
    }
  }

  getParentProduct(): string {
    return this.activatedRoute.snapshot.queryParamMap.get('parentProduct');
  }

  getParentProductName(): string {
    return this.activatedRoute.snapshot.queryParamMap.get('parentProductName')?.replace(/[”"]/g, '');
  }

  getFollowActionUrl(): string {
    return atob(this.activatedRoute.snapshot.queryParamMap.get('followActionUrl'))?.replace(/[”"]/g, '');
  }
}
